import { render, staticRenderFns } from "./Storeage.vue?vue&type=template&id=474e7f52&"
import script from "./Storeage.vue?vue&type=script&lang=js&"
export * from "./Storeage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports